module.exports = __webpack_public_path__ + "img/coastCleanUp_041022_A.fa3e5fd9.jpg";